import React,{useEffect} from "react";
import SingleProduct from "../../../shared-components/SingleProduct/SingleProduct";
import SingleCollection from "../../../shared-components/SingleCollection/SingleCollection";
import Wallet from "../../../shared-components/Wallet/Wallet";

import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

// Import Swiper React components
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

function HomeV2() {

  useEffect(() => {
    document.body.classList.add("light-ui");
    return () => {
      document.body.classList.remove("light-ui");
      // Cleanup: Remove the script when the component unmounts
    };
  }, []); 

  AnimationFileLoader();

  return (
    <>
  
      <div
        className="banner ov-hidden"
        data-bg-img="/img/bg/bg-design-shape.png"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              {/* Banner Content */}
              <div className="banner-content mt-xl-5 pt-xl-2 mb-5 mb-lg-0">
                <h1>
                  Digital Collection & Sell on <span>NFTs</span> Marketplace
                </h1>
                <ul className="list-info">
                  <li>
                    <h4>
                      <span className="counter">3</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Artwork</h6>
                  </li>
                  <li>
                    <h4>
                      <span className="counter">9</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Auction</h6>
                  </li>
                  <li>
                    <h4>
                      <span className="counter">6</span>k
                      <span className="c1">+</span>
                    </h4>
                    <h6>Artist</h6>
                  </li>
                </ul>
                <div className="button-group">
                  <NavLink to="create.html" className="btn">
                    <img src="/img/icons/discover.svg" alt="" className="svg" />
                    Discover
                  </NavLink>
                  <NavLink to="create.html" className="btn btn-link btn-link-dark">
                    <img
                      src="/img/icons/create-icon.svg"
                      alt=""
                      className="svg"
                    />
                    Create NFT
                  </NavLink>
                </div>
              </div>
              {/* End Banner Content */}
            </div>
            <div className="col-lg-6">
              {/* Banner IMG */}
              <div className="banner-img mb-60 mb-lg-0">
                <img src="/img/media/banner-img.png" alt="" />

                <div className="banner-img-content">
                  <h2>Do NavLink Portrait Painting Artwork!</h2>

                  {/* List Info */}
                  <ul className="list-info text-white style--two">
                    <li>
                      <h5>Current Bid</h5>
                      <h4 className="mb-0">
                        <img src="/img/icons/eth.svg" alt="" className="svg" />{" "}
                        03.66 ETH
                      </h4>
                    </li>
                    <li>
                      <h5>Auction Ending In</h5>
                      <div className="countdown-wrap">
                        <img src="/img/icons/time.svg" alt="" className="svg" />
                        <ul className="countdown">
                          <li>
                            <span className="hours">00</span>
                          </li>
                          <li className="ms-1 me-1"> : </li>
                          <li>
                            <span className="minutes">00</span>
                          </li>
                          <li className="ms-1 me-1"> : </li>
                          <li>
                            <span className="seconds">00</span>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                  {/* End List Info */}

                  {/* Button Group */}
                  <div className="button-group">
                    <NavLink to="#" className="btn-circle love-react mr-10"></NavLink>

                    <div className="dropdown mr-10">
                      <button
                        className="btn-circle dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        <img src="/img/icons/share.svg" alt="" className="svg" />
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <NavLink
                            className="dropdown-item"
                            
                            to="https://www.facebook.com/"
                          >
                            <img src="/img/icons/facebook.svg" alt="" /> Share on
                            Facebook
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="dropdown-item"
                            
                            to="https://www.twitter.com/"
                          >
                            <img src="/img/icons/twitter.svg" alt="" /> Share on
                            Twitter
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="dropdown-item"
                            
                            to="https://www.Instagram.com/"
                          >
                            <img src="/img/icons/instagram.svg" alt="" /> Share
                            on Instagram
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            className="dropdown-item"
                            
                            to="https://www.linkedin.com/"
                          >
                            <img src="/img/icons/linkedin.svg" alt="" /> Share on
                            Linkedin
                          </NavLink>
                        </li>
                      </ul>
                    </div>

                    <NavLink to="item-details.html" className="btn btn-sm">
                      <img
                        src="/img/icons/judge-icon.svg"
                        alt=""
                        className="svg"
                      />
                      Place Bid
                    </NavLink>
                  </div>
                  {/* End Button Group */}
                </div>
              </div>
              {/* End Banner IMG */}
            </div>
          </div>
        </div>
      </div>
      {/* End Banner */}

      {/* About */}
      <section className="pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              {/* Section Title */}
              <div className="section-title mb-4">
                <h2>Who Trust In Us</h2>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-lg-7">
              <div className="content mt-n1">
                <p>
                  NFTs are non-fungible tokens. They are unique items that you
                  can't replace with something else. For example, NavLink
                  one-of-NavLink-kind trading card is an NFT – you can't just replace
                  it with any other card. If you trade your card for some other
                  card, you have something different. These differ from fungible
                  items, which are often the same as each other.
                </p>
                <p>
                  Example, NavLink one-of-NavLink-kind trading card is an NFT – you can't
                  just replace it with any other card. If you These differ from
                  fungible items, which are often the same as each other
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-5 pt-1">
            <div className="col-12">
              {/* Swiper */}

              <Swiper
                modules={[Autoplay]}
                className="swiper walletCarousel"
                loop={true}
                navigation={true}
                spaceBetween={30}
                slidesPerView="auto"
                autoplay={true}
              >
                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet1.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet2.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet3.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet4.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet5.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet6.png"
                  ></Wallet>
                </SwiperSlide>

                {/* In order to make the infine loop working we have to add double the amount of slides  get the slideperview from swiper hook => params => slidesPerView */}

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet1.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet2.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet3.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet4.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet5.png"
                  ></Wallet>
                </SwiperSlide>

                <SwiperSlide>
                  <Wallet
                    classList="wallet"
                    to="https://metamask.io/download.html"
                    imgSrc="/img/media/wallet6.png"
                  ></Wallet>
                </SwiperSlide>

                {/*  */}
              </Swiper>

            </div>
          </div>
        </div>
      </section>
      {/* End About */}

      {/* Video */}
      <div className="vdo_sec">
        <div className="container">
          <div className="row">
            <div className="col">
              {/* Video Button Wrapper */}
              <div className="vdo-btn-wrapper gradient-box">
                <img
                  src="/img/icons/bg-play.png"
                  className="gradient-box-icon"
                  alt=""
                />
                <NavLink
                  to="https://www.youtube.com/watch?v=gfGuPd1CELo"
                  className="vdo_btn popup-video icon-mobile-white"
                >
                  <img src="/img/icons/play.svg" alt="" className="svg" />
                  <h3 className="text-white">Learn How Anefty Working!</h3>
                </NavLink>
              </div>
              {/* End Video Button Wrapper */}
            </div>
          </div>
        </div>
      </div>
      {/* End Video */}

      {/* Live Auction */}
      <section className="pt-120 pb-120 section-shape">
        <div className="container mt-60 mt-lg-0">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              {/* Section Title */}
              <div className="section-title text-center">
                <h2>Live Auctions</h2>
                <p>
                  NFTs are non-fungible tokens. They are unique items that you
                  can't replace with something else. for trading card is an NFT
                  – you can't just replace it with any other card.
                </p>
              </div>
              {/* End Section Title */}
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* Swiper */}
              <Swiper
                className="swiper live-auction"
                loop={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                autoplay={true}
                modules={[Autoplay]}
                spaceBetween={30}
                slidesPerView={3}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                }}
              >
                <SwiperSlide>
                  <SingleProduct
                    classList="single-product style--one"
                    productName="Liquid Forest Princess"
                    productPrice="03.66 ETH"
                    info="00 : 00 : 00 LEFT"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <SingleProduct
                    classList="single-product style--one"
                    productName="Liquid Forest Princess"
                    productPrice="03.66 ETH"
                    info="00 : 00 : 00 LEFT"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <SingleProduct
                    classList="single-product style--one"
                    productName="Liquid Forest Princess"
                    productPrice="03.66 ETH"
                    info="00 : 00 : 00 LEFT"
                  />
                </SwiperSlide>

                {/* In order to make the infine loop working we have to add double the amount of slides  get the slideperview from swiper hook => params => slidesPerView */}
                <SwiperSlide>
                  <SingleProduct
                    classList="single-product style--one"
                    productName="Liquid Forest Princess"
                    productPrice="03.66 ETH"
                    info="00 : 00 : 00 LEFT"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <SingleProduct
                    classList="single-product style--one"
                    productName="Liquid Forest Princess"
                    productPrice="03.66 ETH"
                    info="00 : 00 : 00 LEFT"
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <SingleProduct
                    classList="single-product style--one"
                    productName="Liquid Forest Princess"
                    productPrice="03.66 ETH"
                    info="00 : 00 : 00 LEFT"
                  />
                </SwiperSlide>

              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* End Live Auction */}

      {/* Explore Feeds */}
      <section className="pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              {/* Section Title */}
              <div className="section-title text-center">
                <h2>Explore Feeds</h2>
                <p>
                  NFTs are non-fungible tokens. They are unique items that you
                  can't replace with something else. for trading card is an NFT
                  – you can't just replace it with any other card.
                </p>
              </div>
              {/* End Section Title */}
            </div>
          </div>
        </div>

        {/* Swiper */}
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          className="swiper explore-feeds"
          loop={true}
          navigation={true}
          spaceBetween={30}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          autoplay={true}
        >

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Colorful Abstract Painting"
              productPrice="0.69  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Liquid Forest Princess"
              productPrice="0.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="3.99  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.79  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          {/*  */}
          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Colorful Abstract Painting"
              productPrice="0.69  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Liquid Forest Princess"
              productPrice="0.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.89  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="3.99  ETH"
              info="2 to 100"
            />
          </SwiperSlide>

          <SwiperSlide className="mb-60">
            <SingleProduct
              classList="single-product style--one"
              productName="Animal Girl Painting"
              productPrice="1.79  ETH"
              info="2 to 100"
            />
          </SwiperSlide>
          {/* End */}

        </Swiper>
      </section>
      {/* End Explore Feeds */}

      {/* Support Center */}
      <section className="pb-120 mt-lg-120 pt-60 pt-lg-0 section-shape section-shape-right">
        <div className="container">
          <div className="row gutter-60">
            <div className="col-lg-4">
              {/* Support IMG */}
              <div className="support-img">
                <img src="/img/media/support-img.png" alt="" />
              </div>
              {/* End Support IMG */}
            </div>
            <div className="col-lg-8">
              <div className="d-flex justify-content-end mb-60">
                {/* Gradient box */}
                <div className="quick-contact gradient-box">
                  <img
                    src="/img/icons/phone.png"
                    className="gradient-box-icon"
                    alt=""
                  />
                  <h3 className="text-white">Quick Contact Us:</h3>
                  <NavLink to="tel:0032525700">+003 252-5700</NavLink>
                </div>
                {/* End Gradient box */}
              </div>

              {/* Support Content */}
              <div className="support-content">
                {/* Section Title */}
                <div className="section-title">
                  <h2>Support Center</h2>
                  <p>
                    Anefty are non-fungible tokens. they are unique items that
                    you can't replace with something else. for example, NavLink one of
                    NavLink kind trading card is an NFT – you can't just replace it
                    with any other card.
                  </p>
                </div>
                {/* End Section Title */}

                {/* Support Form */}
                <form action="#" className="support-form row">
                  <div className="col-lg-6">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="col-lg-6">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder="Write Message Here"
                      required
                    ></textarea>
                    <button type="submit" className="btn">
                      <img src="/img/icons/mail.svg" alt="" className="svg" />{" "}
                      Send Request
                    </button>
                  </div>
                </form>
                {/* End Support Form */}
              </div>
              {/* End Support Content */}
            </div>
          </div>
        </div>
      </section>
      {/* End Support Center */}

      {/* Top Collection */}
      <section className="pt-120 pb-90">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              {/* Section Title */}
              <div className="section-title text-center">
                <h2>Top Collections</h2>
                <p>
                  NFTs are non-fungible tokens. They are unique items that you
                  can't replace with something else. for trading card is an NFT
                  – you can't just replace it with any other card.
                </p>
              </div>
              {/* End Section Title */}
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Meka_Verse"
                price="$203,621,269"
                count="01"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Bored_YachtClub"
                price="$118,321,276"
                count="02"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Bambooz_lers"
                price="$10,429,103"
                count="03"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="The_Humanoids"
                price="$7,991,156"
                count="04"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Stacked_Toadz"
                price="$6,700,653"
                count="05"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Mutant_Cats"
                price="$22,278,069"
                count="06"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Mutant_YachtClub"
                price="$10,307,676"
                count="07"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Optics_PeopleS"
                price="$19,359,169"
                count="08"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Goofy_Oversized"
                price="$203,621,269"
                count="09"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Cyber_Kongz"
                price="$7,227,956"
                count="10"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="The_DogePound"
                price="$6,609,169"
                count="11"
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              <SingleCollection
                name="Halloween_Bears"
                price="$4,673,966"
                count="12"
              />
            </div>
          </div>
        </div>
      </section>
      {/* End Top Collection */}

    </>
  );
}

export default HomeV2;
